/**
 * useSendingContext.ts — shared React Query hook for the caller's sending
 * domain (GET /api/v1/mailbridge/sending-context). Every notice on a page
 * shares the same cache entry; invalidate SENDING_CONTEXT_QUERY_KEY after
 * anything that can change it (mailbox connected, tick run, domain added).
 */
import { useQuery } from "@tanstack/react-query";

import { mailbridgeApi } from "@/services/apiClient";
import type { SendingContext } from "@/types/common";

export const SENDING_CONTEXT_QUERY_KEY = ["mailbridge", "sending-context"] as const;

export function useSendingContext(enabled = true) {
  return useQuery<SendingContext>({
    queryKey: SENDING_CONTEXT_QUERY_KEY,
    queryFn: () => mailbridgeApi.sendingContext(),
    staleTime: 60_000,
    retry: false,
    enabled,
  });
}
